import type { FirstDataRenderedEvent } from 'ag-grid-community'

// RU columns eat up a lot of dead space; update headings or don't autosize
export const autoSizeAllColumns = (event: FirstDataRenderedEvent) => {
  event.api.autoSizeAllColumns()
}
